




























































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { BulletinModule } from '@/app/store/modules/bulletin'
import { AdditionalModule } from '@/app/store/modules/additionalinfo'
import { RecomendationModule } from '@/app/store/modules/recomendation'
import { MasterModule } from '@/app/store/modules/master'
@Component
export default class extends Vue {
  @Prop({}) public clearRowSelected
  @Prop({}) public selected: any[] | undefined
  @Prop({}) public additionalData
  @Prop({}) public bulletinData
  @Prop({}) public recomendationData
  @Prop({}) public TrainingCategoryData
  @Prop({}) public GuideCategoryData

  public TrainingId: string = ''
  public byTrainingMaterial(text) {
    const find = this.TrainingOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.TrainingOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getTrainingMaterial()
    }
    const a = text.split('/')[1]
    if (this.TrainingOptions.length > 0 && text.length >= 3) {
      this.TrainingId =
        this.TrainingOptions.find((e) => e.id === Number(a)).id || ''
    }
  }
  public TrainingOptions: any = []
  public get TrainingMaterial() {
    this.TrainingOptions = MasterModule.TrainingMaterialData.data
    return MasterModule.TrainingMaterialData
  }

  public GuideId: string = ''
  public byGuideMaterial(text) {
    const find = this.GuideOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.GuideOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getGuideMaterial()
    }
    const a = text.split('/')[1]
    if (this.GuideOptions.length > 0 && text.length >= 3) {
      this.GuideId = this.GuideOptions.find((e) => e.id === Number(a)).id || ''
    }
  }
  public GuideOptions: any = []
  public get GuideMaterial() {
    this.GuideOptions = MasterModule.GuideMaterialData.data
    return MasterModule.GuideMaterialData
  }

  public InfoId: string = ''
  public byInfoMaterial(text) {
    const find = this.InfoOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.InfoOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getInfoMaterial()
    }
    const a = text.split('/')[1]
    if (this.InfoOptions.length > 0 && text.length >= 3) {
      this.InfoId = this.InfoOptions.find((e) => e.id === Number(a)).id || ''
    }
  }
  public InfoOptions: any = []
  public get InfoMaterial() {
    this.InfoOptions = MasterModule.InfoMaterialData.data
    return MasterModule.InfoMaterialData
  }

  public BulletinId: string = ''
  public byBulletinMaterial(text) {
    const find = this.BulletinOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.BulletinOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getBulletinMaterial()
    }
    const a = text.split('/')[1]
    if (this.BulletinOptions.length > 0 && text.length >= 3) {
      this.BulletinId =
        this.BulletinOptions.find((e) => e.id === Number(a)).id || ''
    }
  }
  public BulletinOptions: any = []
  public get BulletinMaterial() {
    this.BulletinOptions = MasterModule.BulletinMaterialData.data
    return MasterModule.BulletinMaterialData
  }

  // public get optionsTrainingFile() {
  //   const array: any = [{ value: 0, text: 'Select Category' }]
  //   for (const item of this.TrainingCategoryData) {
  //     array.push({
  //       value: item.id,
  //       text: item.name,
  //     })
  //   }
  //   return array
  // }
  // Guide Category Data
  // public get optionsGuideCategory() {
  //   const array: any = [{ value: 0, text: 'Select Category' }]
  //   for (const item of this.GuideCategoryData) {
  //     array.push({
  //       value: item.id,
  //       text: item.name,
  //     })
  //   }
  //   return array
  // }

  // public get optionsTrainingCategory() {
  //   const array: any = [{ value: 0, text: 'Select Category' }]
  //   for (const item of this.TrainingCategoryData) {
  //     array.push({
  //       value: item.id,
  //       text: item.name,
  //     })
  //   }
  //   return array
  // }

  // Bulletin Data
  // public get optionsFilesBulletin() {
  //   const array: any = [{ value: 0, text: 'Select File' }]
  //   for (const item of this.bulletinData.filter(
  //     (e) => e.isRecommended === false
  //   )) {
  //     array.push({
  //       value: item.id,
  //       text: item.title,
  //     })
  //   }
  //   return array
  // }

  // Additional Data
  // public get optionsFilesAdditional() {
  //   const array: any = [{ value: 0, text: 'Select File' }]
  //   for (const item of this.additionalData.filter(
  //     (e) => e.isRecommended === false
  //   )) {
  //     array.push({
  //       value: item.id,
  //       text: item.title,
  //     })
  //   }
  //   return array
  // }

  public materialSelect: string = 'Select Material'
  public materialId: number = 0
  public training: string = ''
  public bulletin: string = ''
  public info: string = ''
  public guide: string = ''
  public categorySelect: number = 0
  public fileSelect: number = 0
  public showSelectCategory: boolean = false
  public showInputTraining: boolean = false
  public showInputGuide: boolean = false
  public showInputInfo: boolean = false
  public showInputBulletin: boolean = false
  public isDisable: boolean = true
  public showSelectFile: boolean = false
  public optionsCategory: any = []
  public optionsFile: any = []
  // Options Select
  public optionsMaterial = [
    { value: 'Select Material', text: 'Select Material' },
    { value: 'Training', text: 'Training' },
    { value: 'Guide', text: 'Guide' },
    { value: 'Bulletin', text: 'Bulletin' },
    { value: 'Info', text: 'Info' },
  ]

  public selectChange() {
    if (this.materialSelect === 'Training') {
      this.showInputTraining = true
      this.showInputInfo = false
      this.showInputBulletin = false
      this.showInputGuide = false
      this.isDisable = false
    } else if (this.materialSelect === 'Guide') {
      this.showInputGuide = true
      this.showInputTraining = false
      this.showInputInfo = false
      this.showInputBulletin = false
      this.isDisable = false
    } else if (this.materialSelect === 'Bulletin') {
      this.showInputBulletin = true
      this.showInputTraining = false
      this.showInputGuide = false
      this.showInputInfo = false
      this.isDisable = false
    } else if (this.materialSelect === 'Info') {
      this.showInputInfo = true
      this.showInputBulletin = false
      this.showInputTraining = false
      this.showInputGuide = false
      this.isDisable = false
    } else {
      this.showInputTraining = false
      this.showInputGuide = false
      this.showInputInfo = false
      this.showInputBulletin = false
      this.isDisable = true
    }
  }
  public categroyChanger() {
    if (this.categorySelect !== 0) {
      this.showSelectFile = true
    } else {
      this.showSelectFile = false
    }
  }
  public disabledSelect = true
  public disabledFile = true
  public get disabled(): boolean {
    return this.fileSelect === 0 ? true : false
  }

  public postRecommended() {
    if (this.recomendationData.data.length < 10) {
      if (this.materialSelect === 'Training') {
        this.materialId = Number(this.training.split('/')[1])
      }
      if (this.materialSelect === 'Guide') {
        this.materialId = Number(this.guide.split('/')[1])
      }
      if (this.materialSelect === 'Bulletin') {
        this.materialId = Number(this.bulletin.split('/')[1])
      }
      if (this.materialSelect === 'Info') {
        this.materialId = Number(this.info.split('/')[1])
      }

      const dataToPost = {
        contentId: this.materialId,
        contentType: this.materialSelect.toLowerCase(),
      }
      RecomendationModule.postRecomendation(dataToPost)
      this.showSelectFile = false
      this.showSelectCategory = false
      this.materialSelect = 'Select Material'
      this.fileSelect = 0
    } else {
      this.$notify({
        type: 'error',
        title: `Can't Post`,
        message: 'Maximum Recommendation Data 10',
        duration: 4000,
      })
      this.showSelectFile = false
      this.showSelectCategory = false
      this.materialSelect = 'Select Material'
      this.fileSelect = 0
    }
  }
}
